import { render, staticRenderFns } from "./OpenaiSuggestedHashtags.vue?vue&type=template&id=4cfaeb04"
import script from "./OpenaiSuggestedHashtags.vue?vue&type=script&lang=js"
export * from "./OpenaiSuggestedHashtags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports